import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueTour from 'vue-tour'
import VueChatScroll from 'vue-chat-scroll'

import vuetify from './plugins/vuetify'
import router from './plugins/router'
import i18n from './plugins/i18n'
import store from './plugins/vuexStore'
import './plugins/msal'

import App from './App.vue'
import Luxon from './plugins/LuxonPlugin.js'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueChatScroll)
Vue.use(VueAxios, axios);
Vue.use(VueTour)
Vue.use(Luxon)

Vue.config.productionTip = false;

/*router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if ($msal.getAllAccounts().length === 0 && localStorage.getItem("AccessToken") === null) {
      next({
        path: "/error",
        query: { errorCode: 0x4001, targetRoute: to.fullPath},
      });
    } else {
      next();
    }
  } else {
    next();
  }
});*/

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');